import React, { useEffect, useState } from 'react';

import { useQuery } from '@ubisend/pulse-hooks';

import { useImportReducer } from '../reducers/index';
import { ImportsContext } from '../Contexts/index';

const ImportsProvider = ({ children }) => {
  const [open, setOpen] = useState();

  const reducer = useImportReducer();

  const { data, isSuccess, isLoading } = useQuery({
    queryKey: [
      'imports'
    ]
  });

  // Dispatch imports when data is available
  useEffect(() => {
    if (isSuccess) {
      reducer.dispatch({ type: 'SET_IMPORTS', imports: data.data });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isSuccess]);

  const context = {
    ...reducer,
    open,
    setOpen,
    loading: isLoading || Boolean(!reducer.imports),
  };

  return (
    <ImportsContext.Provider value={context}>
      {children}
    </ImportsContext.Provider>
  );
};

export default ImportsProvider;
